<template>
  <div style="font-size: 13px;">
    <div v-for="(item, key) in treeData" :key="`1-${key}`">
      <div class="message-bubble">
        <p>{{item.title}}</p>

        <br/>

        <div :class="{'flex flex-wrap justify-content-center': interativeFlow}">
          <div v-for="(child, key) in item.children" :key="`2-${key}`">
            <div v-if="interativeFlow">
              <vs-chip class="shadow">{{ child.title }}</vs-chip>
            </div>
            <div v-else>
              <p>{{`${key + 1} - ${child.title}`}} </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="message-bubble message-bubble-answer">
      <p>{{ interativeFlow ? 'Explicar o motivo' :'2'}}</p>
    </div>

    <div v-for="(item, key) in treeData[0].children" :key="`3-${key}`">
      <div class="message-bubble" v-if="key === 1">
        <p>{{optionTitle(item.title)}}</p>
        
        <br/>

        <div :class="{'flex flex-wrap justify-content-center': interativeFlow}">
          <div v-for="(child, key) in item.children" :key="`4-${key}`">
            <div v-if="interativeFlow">
              <vs-chip class="shadow">{{ child.title }}</vs-chip>
            </div>
            <div v-else>
              <p>{{`${key + 1} - ${child.title}`}} </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="message-bubble message-bubble-answer">
      <p>{{ interativeFlow ? 'Data de vencimento' :'1'}}</p>
    </div>

    <div v-for="(item, key) in treeData[0].children[1].children" :key="`5-${key}`">
      <div class="message-bubble" v-if="key === 0">
        <p>{{optionTitle(item.title)}}</p>
        
        <br/>

        <div>
          <p v-for="(child, key) in item.children" :key="`6-${key}`">
            {{child.title}}
          </p>
        </div>
      </div>
    </div>

    <div style="clear: both;"></div>

    <hr color="#ddd" />

    <p align="center">Fim do Fluxo</p>

    <div style="clear: both;"></div>
  </div>
</template>

<script>
import { hasCloud } from "../../utils";

export default {
  props: {
    isPassive: {
      type: Boolean,
      required: true
    },
    treeData: {
      type: Array,
      required: true
    }
  },
  computed: {
    interativeFlow(){
      return hasCloud() && this.isPassive && !!parseInt(this.$store.state.settings.settings.buttons_in_passive_flow)
    }
  },
  methods: {
    optionTitle(title) {
      return title.substr(title.indexOf('-') + 1, title.length)
    }
  }
}
</script>

<style lang="scss">
  .message-bubble {
    float: right;
    background: #DBF6C5;
    border-radius: .4em;
    clear: both;
    border-bottom: 1px solid rgba(0,0,0,.3);
    padding: 3px 6px;
    max-width: 75%;
    margin-bottom: 10px;

    > p {
      text-align: left;
      padding: 0 2px;
    }

    > img {
      padding: 1px;
      background-color: #f5f5f5;
      border-radius: .4em;
      max-width: 200px;
      max-height: 150px;
    }
  }

  .message-bubble:not(:last-child) {
    margin-bottom: 10px;
  }

  .message-bubble-answer {
    background-color: #eee;
    float: left;

    > p {
      text-align: left;
    }
  }
</style>